import { cn } from "@/lib/utils";
import { store } from "../../store";

export type FooterProps = {
    className?: string;
};

export const Footer = ({ className }: FooterProps): JSX.Element => {
    const t = store.i18n.t;

    return (
        <div className={cn("text-center text-xs text-gray-400", className)}>
            <span>© {new Date().getFullYear()} ELOKON Group</span> ·{" "}
            <span>{t("page.login.allRightsReserved")}</span> ·{" "}
            <a href="https://www.elofleet.com/privacy-policy" className="hover:underline">
                {t("footer.privacyPolicy")}
            </a>
        </div>
    );
};
